module.exports = require('./src/browser-md5-file');



//////////////////
// WEBPACK FOOTER
// ./~/browser-md5-file/index.js
// module id = 716
// module chunks = 1